export class JsonItem {
    Id: string;
    Json: any;
}

export class PickListItem {
    Id: number;
    Value: string;
}

export class PickListItemSorted {
    Id: number;
    Value: string;
    SortOrder: number;
}

export class PickListItemString {
    Id: string;
    Value: string;
}
